import * as React from 'react';

import BaseTransactionListLayout from './BaseTransactionListLayout';
import TransactionReceiptPopup from '../containers/transactions/TransactionReceiptPopup';

export default function ({ transactionId }) {
  return BaseTransactionListLayout(
    <TransactionReceiptPopup transactionId={transactionId} />
  );
};
